import { Component, ElementRef, EventEmitter, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { QResult, QueovalDate } from '../../../../../models';
import { BilanPedagogique, ObjectifPedagogique, OPLearner } from '../../../../../models/formation';
import { CoreService, HttpService, QueovalDateService } from '../../../../../services';
import { ToastService } from '../../../../../toast';
import { StageService } from '../../services/stage-modal.service';




@Component({
  selector: 'queoval-stage-create-objectifs',
  templateUrl: './create-objectif.component.html',
  styleUrls: ['./create-objectif.component.css']
})


/**
 * Composant qui permets de créer des objectifs pédagogiques
 */
export class CreateObjectifComponent implements OnInit {

  // #region CONSTRUCTEUR
  constructor(
    private http: HttpService,
    private indParam: CoreService,
    public service: StageService,
    public qDateService: QueovalDateService,
    private renderer: Renderer2,
    private toastservice: ToastService
  ) { }
  // #endregion


  // #region variables globales

  /* date de création */
  public DateCreation: QueovalDate;

  /* commentaires */
  public CommentCreation: string;

  /**
   * Liste des objectifs pédagogiques
   */
  public ObjectifList: Array<ObjectifPedagogique>;

  /**
   * Booléen pour le chargement
   */
  public ObjectifLoaded: boolean;

  /**
   * Booléen pour l'enregistrement des bilan
   */
  public SaveBilanLoaded: boolean;

  @ViewChild('objpedaListContainer') objpedaListContainer: ElementRef;

  @Output('bilanGenere') bilanGenere: EventEmitter<boolean> = new EventEmitter<boolean>();

  // #endregion

  //#region CYCLE DE VIE
  public ngOnInit(): void {
    // date du jour par défaut
    this.DateCreation = this.qDateService.Now();

    this.ObjectifLoaded = true;

    // Récupération des objectifs pédagogiques du stage
    this.http.getHttp<QResult<Array<ObjectifPedagogique>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Certification/INIT_CREATE_OBJECTIF/${this.service.Stage.Ident}/`).subscribe(
      (result: QResult<Array<ObjectifPedagogique>>) => {
        this.ObjectifList = result.Value;
        this.ObjectifLoaded = false;
      });
  }

  //#endregion

  // #region FONCTIONS PUBLIQUES

  public GenerateBilan(): void {
    this.SaveBilanLoaded = true;
    let modelBilan = new BilanPedagogique();
    modelBilan.Date = this.DateCreation;
    modelBilan.Comment = this.CommentCreation;
    modelBilan.IdStage = this.service.Stage.Ident;
    modelBilan.ObjPedaList = this.ObjectifList;
    this.http.postHttp<QResult<Array<BilanPedagogique>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Certification/GENERATE_BILAN_PEDAGOGQUE`, modelBilan).subscribe(
      (result: QResult<Array<BilanPedagogique>>) => {
        // emit de l'output pour fermer la modale et recharger les données
        if (!result.HasError) {
          this.bilanGenere.emit(true);
          this.toastservice.showSuccessToast('Les bilans ont bien été générés');
        }
        this.SaveBilanLoaded = false;
      });
  }

  /**
   * Ouverture en accordéon d'un objectif pédagogique'
   * @param event
   */
  public expendList(event: any) {

    let element: any = event.currentTarget ? event.currentTarget.parentElement : event;


    if (element.classList.contains('q-objpeda-expanded')) {
      this.renderer.removeStyle(element, 'max-height');
      this.renderer.removeClass(element, 'q-objpeda-expanded');
      var chevronelem = element.querySelector('.fa-chevron-up');
      this.renderer.removeClass(chevronelem, 'fa-chevron-up');
      this.renderer.addClass(chevronelem, 'fa-chevron-down');
      
    } else {
      //this.objpedaListContainer.nativeElement.querySelectorAll('.q-objpeda-expanded').forEach((e: ElementRef) => {
      //  this.renderer.removeStyle(e, 'max-height');
      //  this.renderer.removeClass(e, 'q-objpeda-expanded');
      //});

      var chevronelem = element.querySelector('.fa-chevron-down');
      this.renderer.removeClass(chevronelem, 'fa-chevron-down');
      this.renderer.addClass(chevronelem, 'fa-chevron-up');
      this.renderer.addClass(element, 'q-objpeda-expanded');
      this.renderer.setStyle(element, 'max-height', `${element.scrollHeight}px`);
    }
  }

/**
 * Selection d'une atteinte pour un apprennant
 * @param learner
 * @param value
 */
  public UpdateObjectifState(learner: OPLearner, value: string) {
    learner.ObjectifState = value;
  }

  /**
   *  Selection d'une atteinte pour toute une liste d'apprennant
   * @param learnerList
   * @param value
   */
  public SetAllObjectifState(learnerList: Array<OPLearner>, value: string) {
    learnerList.forEach((learner: OPLearner) => {
      learner.ObjectifState = value;
      });
  }

  /**
   * Récupération des valeurs d'une atteinte pour toute une liste d'apprennant pour savoir s'ils sont tous cochés
   * @param learnerList
   * @param value
   */
  public GetAllObjectifState(learnerList: Array<OPLearner>, value: string) {
    return learnerList.filter(learner => learner.ObjectifState != value).length == 0;
  }

  //#endregion



  // #region FONCTIONS PRIVES
  


  //#endregion
}
